import { useState } from "react";
import DeleteConfirmationDialog from "../../../../Util/DeleteConfirmationDialog";

const DeleteContentModal = ({
  showModal,
  toggleShowModal,
  handleDelete,
  setErrorMsg,
  setShowError,
  setShowSuccess,
  subText,
  deleteButtonText = "Delete",
  cancelButtonText = "Cancel",
  errorMessage = "An error occurred. Please try again.",
  resourceName,
  resourceType,
  confirmationValue,
  confirmLabel,
  selectedItem,
}) => {
  const [errorMessageState, setErrorMessageState] = useState("");
  const [isDeleting, setIsDeleting] = useState(false);

  const handleConfirm = async () => {
    setIsDeleting(true);
    try {
      const isDeleted = await handleDelete?.(selectedItem);
      if (isDeleted) {
        setErrorMessageState("");
        toggleShowModal();
        setShowSuccess?.(true);
        setTimeout(() => {
          setShowSuccess?.(false);
        }, 5000);
        return true;
      }

      const resolvedMessage =
        errorMessage ||
        "Unable to delete this content item. Please ensure it is not in use and try again.";

      setErrorMessageState(resolvedMessage);
      setShowError?.(true);
      setErrorMsg?.(resolvedMessage);
    } catch (error) {
      const resolvedMessage =
        error?.message ||
        errorMessage ||
        "Unable to delete this content item. Please ensure it is not in use and try again.";

      setErrorMessageState(resolvedMessage);
      setShowError?.(true);
      setErrorMsg?.(resolvedMessage);
    } finally {
      setIsDeleting(false);
    }

    return false;
  };

  return (
    <DeleteConfirmationDialog
      isVisible={showModal}
      onDismiss={() => {
        setErrorMessageState("");
        toggleShowModal();
      }}
      onConfirm={handleConfirm}
      message={subText}
      resourceName={
        resourceName ||
        confirmationValue ||
        selectedItem?.contentTitle ||
        selectedItem?.title ||
        selectedItem?.name
      }
      resourceType={resourceType || "content item"}
      confirmationValue={
        confirmationValue ||
        resourceName ||
        selectedItem?.contentTitle ||
        selectedItem?.title ||
        selectedItem?.name
      }
      confirmLabel={confirmLabel}
      deleteButtonText={deleteButtonText}
      cancelButtonText={cancelButtonText}
      isDeleting={isDeleting}
      errorMessage={errorMessageState}
    />
  );
};

export default DeleteContentModal;